/**
 * Availability options for intake — aligned with webapp src/assets/data/bookingConstraints.ts.
 * Multi-selects: user can select any combination (or none). No "no preference" option.
 */
export const BOOKING_CONSTRAINTS = [
  { label: 'Not available business hours (8am-5pm)', value: 'no_business_hours' },
  { label: 'Not available evenings (5pm-9pm)', value: 'no_evenings' },
  { label: 'Not available weekends (Sat. and Sun.)', value: 'no_weekends' },
  { label: 'I am flexible', value: 'no_restrictions' },
] as const;

/** Time-of-day constraints (for multi-select). */
export const AVAILABILITY_TIME_OPTIONS = [
  { label: 'Not available business hours (8am-5pm)', value: 'no_business_hours' },
  { label: 'Not available evenings (5pm-9pm)', value: 'no_evenings' },
  { label: 'I am flexible', value: 'no_restrictions' },
] as const;

/** Days constraints (for multi-select). */
export const AVAILABILITY_DAYS_OPTIONS = [
  { label: 'Not available weekends (Sat. and Sun.)', value: 'no_weekends' },
] as const;

/** Intake booking window: earliest slot is 48 hours from now; latest is 14 days out. */
export const INTAKE_BOOKING_MIN_HOURS = 48;
export const INTAKE_BOOKING_MAX_DAYS = 14;

export function getIntakeBookingWindow(): {
  minDate: Date;
  maxDate: Date;
  dateFromIso: string;
  dateToIso: string;
} {
  const now = Date.now();
  const minDate = new Date(now + INTAKE_BOOKING_MIN_HOURS * 60 * 60 * 1000);
  const maxDate = new Date(now + INTAKE_BOOKING_MAX_DAYS * 24 * 60 * 60 * 1000);
  return {
    minDate,
    maxDate,
    dateFromIso: minDate.toISOString(),
    dateToIso: maxDate.toISOString(),
  };
}
